module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAM5JREFUSA3tlE0KwjAQhYtL997/FL2BexeKXsI76HziK2NpnZk2goIDQ0Ly/pKGdt2/vvEGegu1t94VwoGFAzcsgDfro3XGBMzpyYEblidEJh6LSSbQI4Anzpl4TElcR/QCYxO/t0j8nUkz8SmTsy1erHkEq5JLXCOpJYw4c9bC2oSIaQAmzcrfOcl1kvGHX2ToxXXnU2vNxCW02iQjkMEo0MtYIVawg4l+drrzYWNm4k0OhglfZm8gTCBmCyziV+ttllTFkfxj4tUwP4S/A1uOTipF9/nEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_cancel.png
// module id = 18
// module chunks = 0